import React from "react";
import styled from "styled-components";



const ServiceComp = (props) => {
    const { pitch } = props;

    return (
      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Our Expertise</div>
            <h2 className="section-title">Forensic Services</h2>
            <p className="section-description">
              Comprehensive mobile forensics solutions tailored to your investigative needs
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-number">01</div>
              <div className="service-icon">
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <h3>Data Export & Backup</h3>
              <p>
                Securely extract and preserve your valuable mobile data with industry-leading encryption and comprehensive backup solutions. Our processes ensure complete data integrity and chain-of-custody compliance for legal proceedings.
              </p>
            </div>
            <div className="service-card">
              <div className="service-number">02</div>
              <div className="service-icon">
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 3 21 3 21 8"></polyline>
                  <line x1="4" y1="20" x2="21" y2="3"></line>
                  <polyline points="21 16 21 21 16 21"></polyline>
                  <line x1="15" y1="15" x2="21" y2="21"></line>
                  <line x1="4" y1="4" x2="9" y2="9"></line>
                </svg>
              </div>
              <h3>Format Conversion</h3>
              <p>
                Transform complicated mobile data formats into accessible, human-readable documents that can be easily shared and analyzed. We convert proprietary formats into standardized, court-admissible reports.
              </p>
            </div>
            <div className="service-card">
              <div className="service-number">03</div>
              <div className="service-icon">
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="20" x2="12" y2="10"></line>
                  <line x1="18" y1="20" x2="18" y2="4"></line>
                  <line x1="6" y1="20" x2="6" y2="16"></line>
                </svg>
              </div>
              <h3>Data Analysis</h3>
              <p>
                Gain insights from your extracted data with our powerful analysis tools and visualizations designed for clarity and depth. Our experts identify patterns, recover deleted data, and present findings in comprehensive reports.
              </p>
            </div>
          </div>
        </div>
      </section>

    );
};

export default ServiceComp;




